import { ReactNode } from 'react'
import { Response } from 'request-dot-js'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

export const handleSuccessResponseWithMessage =
  (messageText: string | ReactNode = 'Success!') =>
  <T>(response?: Response<T>) => {
    if (response && response.type === 'success') {
      showToastMessage(messageText, 'success')
    }

    return response
  }
